import axios from "../../longLiveAxios";

const baseURL = "/api/locations";

export default {
  getVoivodeships() {
    return axios.get(`${baseURL}/voivodeships`);
  },
  getCounties(voivodeshipId) {
    return axios.get(`${baseURL}/counties?voivodeship_id=${voivodeshipId}`)
  },
  getCommunities(countyId) {
    return axios.get(`${baseURL}/communities?county_id=${countyId}`)
  },
  getCities(communityId) {
    return axios.get(`${baseURL}/cities?community_id=${communityId}`)
  },
  getStreets(cityId) {
    return axios.get(`${baseURL}/streets?city_id=${cityId}`)
  },
  getHouses(streetId) {
    return axios.get(`${baseURL}/houses?street_id=${streetId}`)
  },
  /**
   * Creates new building
   * @param payload - { street: str, number: str, city_id: int }
   * @returns {Promise<any>}
   */
  createBuilding(payload) {
    return axios.post(`${baseURL}/buildings`, payload);
  },
  deleteBuilding(buildingId) {
    return axios.delete(`${baseURL}/buildings/${buildingId}`);
  },
  getUserBuildings(page, cityId, streetId, customStreets, address) {
    page = page || 0;
    let url = `${baseURL}/buildings?page=${page}`;
    if (cityId && cityId !== -1) {
      url += `&city_id=${cityId}`;
    }
    if (streetId && streetId !== -1) {
      url += `&street_id=${streetId}`;
    }
    if (customStreets) {
      url += `&custom_streets=true`;
    }
    if (address) {
      url += `&address=${address}`;
    }
    return axios.get(url);
  },
  getBuildingData(buildingId) {
    return axios.get(`${baseURL}/buildings/${buildingId}`);
  },
  /**
   * Updates building
   * @param buildingId - int
   * @param payload - { street: str, number: str, city_id: int }
   * @returns {Promise<any>}
   */
  updateBuilding(buildingId, payload) {
    return axios.put(`${baseURL}/buildings/${buildingId}`, payload);
  }
}
